<div id="selectlocation" class="subBlockContainer">
  <div class="subBlockContent">
    <child-header [title]="title" (closeEvent)="close()"></child-header>
    <div class="inner-subBlock-wrapper">
      <!-- <div class="page-title-wrapper">
        <div class="title blade-title-font">
          {{title}}
        </div>
        <i class="material-icons closebutton-pullfloat-right" (click)="close()">close</i>
      </div> -->
      <div class="filter-wrapper">
        <div class="searchInputGroup">
          <div class="searchIcon">
            <img src="../images/new_ui/filter.png">
          </div>
          <input class="searchInput" type="text" placeholder="Filter" onfocus="this.placeholder=''" onblur="this.placeholder='Filter'" [(ngModel)]="searchLocation"
            (keyup)="filterLocation()">
        </div>
      </div>

      <div class="shared-outer-wrapper child-body">
        <!-- <mat-divider></mat-divider>
        <mat-table [dataSource]="deliveryAddressListFilter" class="selectlocationtable">
          <ng-container matColumnDef="companyName">
            <mat-cell *matCellDef="let element">
              <p class="description">{{element.companyName}}</p>
              <div class="result-info" style="font-size: 9px;">
                <span>ATT/REF:&nbsp;</span>
                <span>{{element.attnOrRef}}</span><br>
                <span>{{element.addressLine1}}&nbsp;{{element.addressLine2}}&nbsp;{{element.addressLine3}}</span><br>
                <span>{{element.suburb}}&nbsp;{{element.state}}&nbsp;{{element.postcode}}</span><br>
                <span>PHONE:&nbsp;</span>
                <span>{{element.phone}}</span>
              </div>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="button">
            <mat-cell *matCellDef="let element" style="padding-bottom: 70px;">
              <button class="button button-red button-small" (click)="optionSelected(element)">Select</button>
            </mat-cell>
          </ng-container>
          <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
        </mat-table> -->

        <table class="select-table">
          <tbody>
            <ng-container
              *ngFor="let addr of deliveryAddressListFilter">
              <tr class="selection-row">
                <td class="address-col">
                  <p class="description">{{addr.companyName}}</p>
                  <div class="result-info">
                    <span>ATT/REF:&nbsp;</span>
                    <span>{{addr.attnOrRef}}</span><br>
                    <span class="delivery-address">{{addr.addressLine1}}&nbsp;{{addr.addressLine2}}&nbsp;{{addr.addressLine3}}</span><br>
                    <span>{{addr.suburb}}&nbsp;{{addr.state}}&nbsp;{{addr.postcode}}</span><br>
                    <span>PHONE:&nbsp;</span>
                    <span>{{addr.phone}}</span>
                  </div>
                </td>
                <td class="select-button-col">
                  <div class="padding-l-x10">
                    <button class="button button-red button-mid" (click)="optionSelected(addr)">Select</button>
                  </div>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>
    <loading-screen *ngIf="!loadContent" [showBlurTable]="true" (currentLoadingStatus)="onLoading($event)"></loading-screen>
  </div>
</div>
